import {
  PROVIDER_TRANSITS,
  SERVICE_TRANSITS,
  SHIPPING_SERVICE_LABEL,
} from "@/constants/constants";

export function formatService(service) {
  if (!service) return "";
  return (
    SHIPPING_SERVICE_LABEL[service] ||
    service
      .replace("FEDEX_", "")
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
  );
}

export function getDaysFromTransit(transit) {
  if (!transit) return "";
  const days = transit.split(" ")[0] || "0";
  return days.includes("-") ? +days.split("-")[1] : +days;
}

export function getDaysFromRate(rate) {
  const transit =
    rate.transit ||
    PROVIDER_TRANSITS[rate.method.provider] ||
    SERVICE_TRANSITS[rate.method.service];
  if (!transit) return "";
  const days = transit.split(" ")[0] || "0";
  return days.includes("-") ? +days.split("-")[1] : +days;
}

export function getDaysFromService(service) {
  const transit = SERVICE_TRANSITS[service];
  if (!transit) return "";
  const days = transit.split(" ")[0] || "0";
  return days.includes("-") ? +days.split("-")[1] : +days;
}

export function getDaysFromProvider(provider) {
  const transit = PROVIDER_TRANSITS[provider];
  if (!transit) return "";
  const days = transit.split(" ")[0] || "0";
  return days.includes("-") ? +days.split("-")[1] : +days;
}

export function getTransitFromRate(rate) {
  if (!rate) return "";
  return (
    rate.transit ||
    PROVIDER_TRANSITS[rate.method.provider] ||
    SERVICE_TRANSITS[rate.method.service]
  );
}

export function normalizeRates(rates) {
  return rates.map((rate) => {
    return {
      ...rate,
      transit:
        rate.transit ||
        PROVIDER_TRANSITS[rate.method.provider] ||
        SERVICE_TRANSITS[rate.method.service],
    };
  });
}
